import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

export type UpdateChecklistItemsFields = {
    name?: string;
    description?: string;
    reportCodes?: string[];
    categoryId?: string | null;
};

export type UpdateChecklistItemsRequest = {
    id: string;
    fields: UpdateChecklistItemsFields;
}[];

async function updateChecklistItems(request: UpdateChecklistItemsRequest, checklistId: string): Promise<void> {
    const { data } = await api.patch(`/checklists/${checklistId}/items`, request);
    return data;
}

export function useUpdateChecklistItems(checklistId: string): UseMutationResult<void, AxiosError, UpdateChecklistItemsRequest, unknown> {
    return useMutation((req) => updateChecklistItems(req, checklistId), {
        onSettled: () => {
            queryClient.invalidateQueries(['checklists', checklistId]);
            queryClient.invalidateQueries(['checklist-items']);
        },
    });
}
